import { createApp } from 'vue';
import { PiniaColada } from '@pinia/colada';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { initSentry } from './errors/sentry';

import App from './App.vue';
import router from './router';
import { setAuthState } from './composables/auth';
import { syncSentryUser } from './errors/sentry-user';
import { installUi } from './bootstrap/ui';
import { createAppPinia } from './bootstrap/pinia';
import { installErrorHandlers } from './bootstrap/errors';
import { registerChunkReload } from './bootstrap/chunk-reload';
import { pushDataLayerUser } from './bootstrap/analytics';
import { installTranslationGuard } from './bootstrap/translation-guard';

const pinia = createAppPinia();

const app = installUi(createApp(App));

initSentry(app, router);

installTranslationGuard();

installErrorHandlers(app);

app.use(router);
app.use(pinia);
app.use(PiniaColada);

window.Pusher = Pusher;

window.Echo = new Echo({
	broadcaster: 'pusher',
	key: import.meta.env.VITE_PUSHER_APP_KEY,
	cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
	forceTLS: true
});

registerChunkReload(() => window.location.pathname);

//Subscribe to the channel we specified in our Adonis Application
const { hydrateServerSession, getUser } = setAuthState();

// On the Inertia onboarding handoff the session is valid but the SPA's localStorage
// user is empty. Hydrate it before mounting so the router guard sees a logged-in user
// instead of redirecting to the login page. No-op for normal/unauthenticated boots.
hydrateServerSession()
	.catch((e) => console.error('session hydration failed', e))
	.finally(() => {
		// EN-960: hydrateServerSession returns early when a cached user already exists, so
		// setUserData never runs on an ordinary reload of a logged-in SPA. Sync from the cached
		// user before mounting so events raised during render already carry the user.
		syncSentryUser(getUser());
		// The first page view can land before hydration on the handoff, so give GTM the user
		// here too, as App.vue's immediate route-name watcher used to on mount.
		pushDataLayerUser(getUser());
		app.mount('#app');
	});
